import API from "./api";

// GET ALL PRODUCTS
export const getProducts = async () => {
  const res = await API.get("/products");
  return res.data.products;
};

// GET PRODUCT BY ID
export const getProductById = async (id) => {
  const res = await API.get(`/products/${id}`);
  return res.data.product;
};

// CREATE PRODUCT
export const createProduct = async (data) => {
  const res = await API.post("/products", data);
  return res.data.product;
};

// UPDATE PRODUCT
export const updateProduct = async (id, data) => {
  const res = await API.put(`/products/${id}`, data);
  return res.data.product;
};

// DELETE PRODUCT
export const deleteProduct = async (id) => {
  const res = await API.delete(`/products/${id}`);
  return res.data.product;
};

// GET BY CATEGORY
export const getProductsByCategory = async (categoryId) => {
  const res = await API.get(`/products/category/${categoryId}`);
  return res.data.products;
};

// 🔥 FIXED SEARCH (IMPORTANT)
export const searchProducts = async (query) => {
  const res = await API.get(`/products/search?q=${query}`);
  return res.data;   // ✅ backend already returns ARRAY
};